<span class="bar__label">{{ vm?.label }}</span>
<div class="bar__meter">
  <div
    class="bar__track"
    [class.bar__track--empty]="trackEmpty"
    [attr.data-stage]="vm?.stage"
    [style.width.%]="vm?.widthPercent"
  >
    <span class="bar__count" *ngIf="countInside">{{ vm?.count }}</span>
  </div>
  <span class="bar__count bar__count--outside" *ngIf="!countInside">{{ vm?.count }}</span>
  <span class="bar__trailing">
    <span class="bar__percent">
      {{ vm?.percentLabel }}
      <span class="bar__percent-suffix" *ngIf="showPercentSuffix">of started</span>
    </span>
    <span class="bar__chip" *ngIf="vm?.agingLabel">{{ vm.agingLabel }}</span>
  </span>
</div>
